import React from "react";
import Carousel from "react-bootstrap/Carousel";

const MobSlider = () => {
  return (
    <div>
      <Carousel className=" mob_slider ">
        <Carousel.Item>
          <img
            className="d-block mob_carousel_img  w-100"
            src="https://lc247.com/static/media/fullsize.b56cdc1f.jpeg"
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block mob_carousel_img w-100"
            src="https://lc247.com/static/media/login_lc.86a40454.jpeg"
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block mob_carousel_img w-100"
            src="https://lc247.com/static/media/login_lc.86a40454.jpeg"
            alt="Third slide"
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default MobSlider;
